<div class="logo text-center">
  <!-- <a href="https://www.creative-tim.com" class="simple-text logo-mini">
    <div class="logo-image-small">
      <img src="./assets/img/logos/favicon.png" />
    </div>
  </a>
 -->
  <a href="#" class="simple-text logo-normal">
    <img src="./assets/img/logos/logo-vama.png" />
  </a>
</div>

<div class="sidebar-wrapper">
  <ul class="nav">
    <li routerLinkActive="active" *ngFor="let menuitem of menuItems">
      <span *ngIf="menuitem.path == 'collections'">
        <!-- {{menuitem | json}} -->
      </span>
      <!--If is a single link-->
      <a [ngClass]="{'is-link': !menuitem.disabled , 'd-none': menuitem.disabled}" [routerLink]="[menuitem.path]"
        *ngIf="menuitem.type === 'link' && menuitem.display != 'none'">
        <i class="{{ menuitem.icontype }}"></i>
        <p>{{ menuitem.title | translate }}</p>
      </a>
      <!--If it have a submenu-->
      <a [ngClass]="{'is-link': !menuitem.disabled , 'd-none': menuitem.disabled}" data-toggle="collapse"
        href="#{{ menuitem.collapse }}" *ngIf="menuitem.type === 'sub' && menuitem.display != 'none'">
        <i class="{{ menuitem.icontype }}"></i>
        <p>{{ menuitem.title
          | translate }}<b *ngIf="!menuitem.disabled" class="caret"></b></p>
      </a>
      <!--Display the submenu items-->
      <div id="{{ menuitem.collapse }}" class="collapse" *ngIf="menuitem.type === 'sub'">
        <ul class="nav">
          <li [ngClass]="{'is-link': !childitem.disabled , 'd-none': childitem.disabled}" routerLinkActive="active"
            *ngFor="let childitem of menuitem.children">
            <a class="text-left" *ngIf="childitem.display != 'none' && !childitem.disabled"
              [routerLink]="[menuitem.path, childitem.path]">
              <!-- <span class="sidebar-mini-icon">{{ childitem.ab }}</span> -->
              <!-- <span class="sidebar-normal"> -->
              {{childitem.title | translate }}
              <!-- </span> -->
            </a>

            <a data-id="{{ 'buttons.doNotPermissions' | translate }}" class="text-left toltip toltip--top"
              *ngIf="childitem.display != 'none' && childitem.disabled">
              <!-- <span class="sidebar-mini-icon">{{ childitem.ab }}</span> -->
              <!-- <span class="sidebar-normal"> -->
              {{childitem.title | translate }}
              <!-- </span> -->
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>